
import React from "react";

import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Label,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
    Radar,
    Legend,RadarChart,
} from "recharts";


const data = [
    {
      "subject": "Fiber",
      "A": 42,
      "B": 30,
      "fullMark": 100
    },
    {
        "subject": "Cutting",
        "A": 21,
        "B": 27,
        "fullMark": 100
    },
    {
        "subject": "Sliding",
        "A": 29,
        "B": 15,
        "fullMark": 100
    },
    {
      "subject": "Fatigue",
      "A": 73,
      "B": 85,
      "fullMark": 100
    },
    
  ]
export default function RadarChartFunc(){


    return(
   <div width={"100%"}>

            <RadarChart outerRadius={110} width={380} height={310} data={data}>
            <PolarGrid stroke ="white"/>
            <PolarAngleAxis dataKey="subject" stroke="white"/>
            <PolarRadiusAxis angle={45} domain={[0, 100]} stroke="white" />
            <Radar name="Current" dataKey="A" stroke="white" fill="white" fillOpacity={0.4} />
            <Radar name="Mean" dataKey="B" stroke="orange" fill="orange" fillOpacity={0.4} />
            <Legend />
            </RadarChart>
   </div>
        
    )
    }